import type { AppEnvironment } from "./app-environment";

export interface FeatureFlags {
  /** Example gate: turn on experimental renderer work in non-prod first. */
  experimentalRenderer: boolean;
  /** Board domain outline toggle in timeline options. */
  boardModelDebugMenu: boolean;
  /** Book vs universe-time toggle. Off in production until ch1+ch2 look right. */
  universeJourneyView: boolean;
}

export function getFeatureFlags(env: AppEnvironment): FeatureFlags {
  switch (env) {
    case "development":
    case "staging":
      return {
        experimentalRenderer: true,
        boardModelDebugMenu: true,
        universeJourneyView: true,
      };
    case "production":
      return {
        experimentalRenderer: false,
        boardModelDebugMenu: false,
        universeJourneyView: false,
      };
  }
}
